import { createFileRoute } from '@tanstack/react-router'
import { Distribution } from './-components/shared/distribution'
import { DistributionPending } from './-components/shared/distribution-pending'
import { useTeam } from '@/hooks/use-team'
import { reportSearchDeps, prefetchReport } from '@/hooks/use-report'
import { TeamsEmptyState } from './-components/teams/teams-empty-state'
import { ReportError } from './-components/shared/report-error'
import { EmptyState } from './-components/shared/empty-state'

export const Route = createFileRoute('/_app/teams/$teamId/distribution')({
  loaderDeps: ({ search }) => reportSearchDeps(search),
  loader: ({ context, deps, params }) => {
    prefetchReport(context.queryClient, deps, params)
  },
  component: RouteComponent,
  pendingComponent: DistributionPending,
})

function RouteComponent() {
  const { teamId } = Route.useParams()
  const { team } = useTeam()

  // `visibleMembers` is already restricted to the selected self-assessments for `ownsManual` (server-side).
  const members = (team?.visibleMembers ?? []).map((member) => ({ ...member, id: member.id.toString() }))

  if (team?.error === 'teams-see-owns') {
    return <ReportError error="noPermissionsSeeOwns" surface="distribution" />
  }

  if (team?.emptyStateCode) {
    return <EmptyState code={team.emptyStateCode} surface="distribution" />
  }
  // Residual `profile-blocked` with members present → "pick a member" selection state.
  if (team?.error) {
    return <TeamsEmptyState type="select-member" teamId={teamId} />
  }

  return <Distribution profiles={members} data={team.distribution} showFilters />
}
